import { render, staticRenderFns } from "./ExperimentManagement.vue?vue&type=template&id=3a38d80d"
import script from "./ExperimentManagement.vue?vue&type=script&lang=js"
export * from "./ExperimentManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports